import React, { useEffect, useContext } from "react";
import { Table, Button } from "antd";
import { useAtom } from "jotai";
import * as atoms from "../BandejaEvaluacionStorage";
import EvaluacionService from "services/EvaluacionService";
import { SecurityContext } from "context/SecurityContextProvider";
import { EstadoAprobacionEvaluacion } from "enum/EstadoAprobacionEvaluacion";
import { ModalEvaluacion } from "./componentes/ModalEvaluacion";
import { useModalEvaluacion } from "./hooks";
import { ModalFirmarEvaluacion } from "./componentes/ModalFirmar";
import ModalEvaluacionConductor from "./componentes/ModalEvaluacion/ModalEvaluacionConductor";
import useModalEvaluacionConductor from "./hooks/useModalEvaluacionConductor";
import useModalEvaluacionMecanico from "./hooks/useModalEvaluacionMecanico";
import ModalEvaluacionMecanico from "./componentes/ModalEvaluacion/ModalEvaluacionMecanico";

const TablaPendientes = () => {
	const [evaluacionesPendientes, setEvaluacionesPendientes] = useAtom(atoms.evaluacionesPendientesAtom);
	const { mostrarModal } = useModalEvaluacion();
	const { mostrarModalConductor } = useModalEvaluacionConductor();
	const { mostrarModalMecanico } = useModalEvaluacionMecanico();

	const { getUsuarioAutenticado } = useContext(SecurityContext);

	useEffect(() => {
		const cargarDatos = async () => {
			const evaluaciones = await EvaluacionService.listarPorJefeInmediato(
				getUsuarioAutenticado().empresaSeleccionada.id,
				getUsuarioAutenticado().numeroDocumentoIdentidad,
				EstadoAprobacionEvaluacion.PENDIENTE
			);
			setEvaluacionesPendientes(evaluaciones);
		};
		cargarDatos();
	}, []);

	const columnasEvaluacionesPendientes = [
		{
			title: "Periodo",
			dataIndex: "periodo",
			align: "center",
		},
		{
			title: "Numero Documento Identidad",
			dataIndex: ["colaborador", "numeroDocumentoIdentidad"],
			align: "center",
		},
		{
			title: "Nombre Colaborador",
			dataIndex: ["colaborador", "nombreCompleto"],
			align: "center",
		},
		{
			title: "Acciones",
			key: "acciones",
			align: "center",
			render: (registro) =>
				{
					if (registro.tipoEvaluacion != null && registro.tipoEvaluacion === "CONDUCTOR") {
						return (
							<Button type="link" onClick={() => mostrarModalConductor(registro)}>
								Calificar
							</Button>
						);
					} else if (registro.tipoEvaluacion != null && registro.tipoEvaluacion === "MECANICO") {
						return (
							<Button type="link" onClick={() => mostrarModalMecanico(registro)}>
								Calificar
							</Button>
						);
					} else {
						return (
							<Button type="link" onClick={() => mostrarModal(registro)}>
								Calificar
							</Button>
						);
				}
				
				// return (
				// 			<Button type="link" onClick={() => mostrarModal(registro)}>
				// 				Calificar
				// 			</Button>
				// 		);
				},
			// (
			// 	<Button type="link" onClick={() => mostrarModal(registro)}>
			// 		Calificar
			// 	</Button>
			// ),
		},
	];

	return (
		<React.Fragment>
			<Table
				rowKey={(evaluacion) => evaluacion.id}
				dataSource={evaluacionesPendientes}
				columns={columnasEvaluacionesPendientes}
			/>
			<ModalEvaluacion />
			<ModalEvaluacionConductor />
			<ModalEvaluacionMecanico />
			<ModalFirmarEvaluacion />
		</React.Fragment>
	);
};
export default TablaPendientes;
